"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayPeriods = void 0;
var react_query_1 = require("react-query");
var fetchClient_1 = require("../../client/fetchClient");
var paths_1 = require("../../paths");
var atoz_shiftapp_utilities_1 = require("@amzn/atoz-shiftapp-utilities");
var atoz_dashboard_taa_components_1 = require("@amzn/atoz-dashboard-taa-components");
function usePayPeriods(_a) {
    var employeeId = _a.employeeId, _b = _a.shouldFetch, shouldFetch = _b === void 0 ? false : _b;
    var features = (0, atoz_shiftapp_utilities_1.useAssociateContext)().features;
    var taaQueryResult = (0, atoz_dashboard_taa_components_1.usePayPeriod)({
        employeeId: employeeId,
        shouldFetch: shouldFetch
    });
    var ApiPath = (0, paths_1.GET_TIMEOFF_PAYPERIOD_API)(employeeId);
    var internalQueryResult = (0, react_query_1.useQuery)(['payPeriods', ApiPath], function () {
        return (0, fetchClient_1.getData)({
            path: ApiPath,
            useTaaDashboardComponents: features.useTaaDashboardComponents
        });
    }, {
        enabled: !!employeeId && shouldFetch,
        staleTime: 60 * 1000,
        retry: false
    });
    if (features.useTaaDashboardComponents) {
        return taaQueryResult;
    }
    return internalQueryResult;
}
exports.usePayPeriods = usePayPeriods;
